"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthTitleWeek = void 0;
const react_1 = __importDefault(require("react"));
const Month_styles_1 = require("../../Month.styles");
const Text_1 = require("../../../../../Text");
exports.MonthTitleWeek = react_1.default.memo(({ uiTexts, firstWeekDay }) => {
    const weekDays = Object.values(uiTexts);
    const orderedWeekDays = [...weekDays.slice(firstWeekDay), ...weekDays.slice(0, firstWeekDay)];
    return (react_1.default.createElement(Month_styles_1.StyledMonthWeek, null, orderedWeekDays.map((i, idx) => (react_1.default.createElement(Month_styles_1.StyledMonthDay, { key: `month-day-title-${i}${idx}`, weight: Text_1.TEXT_WEIGHT.semiBold }, i.substring(0, 2))))));
});
//# sourceMappingURL=MonthTitleWeek.js.map